import React from "react";
import styles from "../../../../styles/catalog-tags.module.scss";
import { Drawer } from "../../../components/Drawer";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { Icon } from "../../../components/core/Icon";
import { Loading } from "../../../components/Loading";

import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";

import TagForm from "./TagForm";
import TagsList from "./TagsList";

const Steps = {
    TAG_LIST: 0,
    NEW_TAG: 1,
    EDIT_TAG: 2,
    DELETE_TAG: 3,
};

export class ManageTags extends React.Component {
    state = {
        step: Steps.TAG_LIST,
        disabled: false,
        holdingId: null,
        tags: [],
        tagToEdit: null,
        tagToDelete: null,
        loading: false,
    };

    getHeaderTitle() {
        const { step } = this.state;

        const titles = {
            [Steps.TAG_LIST]: "Tags",
            [Steps.NEW_TAG]: "Criar Tag",
            [Steps.EDIT_TAG]: "Editar Tag",
            [Steps.DELETE_TAG]: "Remover Tag",
        };

        return titles[step] || "Tags";
    }

    async loadTags() {
        this.setState({ loading: true });

        const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
        this.setState({ holdingId });

        const catalogTags = await EnvironmentsAPI.getConfigurationsByAlias(
            holdingId,
            "catalog_tags"
        );

        if (catalogTags?.length > 0) {
            this.setState({ tags: catalogTags });
        }
        this.setState({ loading: false });
    }

    async onChangeTags(newTags) {
        this.setState({ loading: true });

        const { holdingId } = this.state;

        await EnvironmentsAPI.putConfigurationsByAlias(
            holdingId,
            "catalog_tags",
            newTags
        );

        this.setState({
            tags: newTags,
            step: Steps.TAG_LIST,
            tagToEdit: null,
            loading: false,
        });
    }

    onEditTag(tag) {
        this.setState({ tagToEdit: tag, step: Steps.EDIT_TAG });
    }

    async onConfirmDeleteTag(tagToDelete) {
        this.setState({
            tagToDelete,
            step: Steps.DELETE_TAG
        })
    }

    async deleteTag() {
        const { tagToDelete } = this.state;
        this.setState({ loading: true });

        const { holdingId, tags: currentTags } = this.state;
        const newTags = currentTags.filter((tag) => tag.id !== tagToDelete.id);

        await EnvironmentsAPI.putConfigurationsByAlias(
            holdingId,
            "catalog_tags",
            newTags
        );

        this.setState({
            tags: newTags,
            loading: false,
            tagToDelete: null,
            step: Steps.TAG_LIST,
        });
    }

    async componentDidMount() {
        await this.loadTags();
    }

    render() {
        const { open, setOpen } = this.props;
        const { step, tags, tagToEdit, tagToDelete, loading } = this.state;

        return (
            <Drawer
                visible={open}
                onClose={() => setOpen(false)}
                title={this.getHeaderTitle()}
                footer={
                    Steps.TAG_LIST === step && (
                        <Button
                            design="primary"
                            className="w-100"
                            disabled={loading}
                            onClick={() => {
                                this.setState({ step: Steps.NEW_TAG });
                            }}
                        >
                            Criar Tag
                        </Button>
                    )
                }
                withoutTransition
            >
                {loading && (
                    <div className={styles.loading}>
                        <Loading />
                    </div>
                )}

                {!loading && (
                    <>
                        {step === Steps.TAG_LIST && (
                            <TagsList
                                manage={true}
                                tags={tags}
                                onEditTag={(tag) => this.onEditTag(tag)}
                                onDeleteTag={(tag) =>
                                    this.onConfirmDeleteTag(tag)
                                }
                            />
                        )}

                        {step === Steps.NEW_TAG && (
                            <TagForm
                                currentTags={tags}
                                onChangeTags={(newTags) =>
                                    this.onChangeTags(newTags)
                                }
                            />
                        )}

                        {step === Steps.EDIT_TAG && (
                            <TagForm
                                currentTags={tags}
                                onChangeTags={(newTags) =>
                                    this.onChangeTags(newTags)
                                }
                                editTag={tagToEdit}
                            />
                        )}

                        {step === Steps.DELETE_TAG && (
                            <div className={styles.removeTag}>
                                <p>
                                    Ao excluir a tag "<strong>{tagToDelete.name}</strong>
                                    ", não será possível recuperá-la depois
                                    disso.
                                </p>
                                <Button
                                    design="primary"
                                    onClick={() => this.deleteTag()}
                                    className="w-100"
                                    disabled={loading}
                                    loading={loading}
                                >
                                    Remover esta tag
                                </Button>
                                <Button
                                    design="default-2"
                                    className="mt-20 w-100"
                                    disabled={loading}
                                    onClick={() =>
                                        this.setState({
                                            tagToDelete: null,
                                            step: Steps.TAG_LIST,
                                        })
                                    }
                                >
                                    Cancelar
                                </Button>
                            </div>
                        )}
                    </>
                )}
            </Drawer>
        );
    }
}
